module.exports = __webpack_public_path__ + "img/photoshop-cc.ba07af9d.svg";